import React from "react";
import { cn } from "@/lib/utils";

export function Wordmark({ className, onClick }) {
    return (
        <a
            href="#top"
            onClick={onClick}
            data-testid="wordmark"
            className={cn("font-display text-xl font-semibold tracking-tight logo-gradient select-none", className)}
        >
            ReplAIced.work
        </a>
    );
}
